// @flow strict

import * as React from 'react'
import cx from 'classnames'
import { SectionThemes, SectionWrapper } from '../../../SectionWrapper'
import SubtitleSection from '../../../SubtitleSection'
import { type SubtitleSectionProps } from '../../../SubtitleSection'

import styles from './ComparisonTable.module.scss'

const CheckMark = () => (
  <svg role="img" width="20" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.76 7.35a1 1 0 10-1.52 1.3l6 7a1 1 0 001.52 0l12-14a1 1 0 10-1.52-1.3L7 13.462 1.76 7.35z"
      fill="#14233C"
      fillRule="evenodd"
      opacity=".8"
    />
    <title>Yes</title>
  </svg>
)

const Cross = () => (
  <svg role="img" width="14" height="14" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M.293.293a1 1 0 011.414 0L7 5.585 12.293.293a1 1 0 011.32-.083l.094.083a1 1 0 010 1.414L8.415 7l5.292 5.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.414 0L7 8.415l-5.293 5.292a1 1 0 01-1.32.083l-.094-.083a1 1 0 010-1.414L5.585 7 .293 1.707A1 1 0 01.21.387z"
      fill="#C8C7CC"
      fillRule="evenodd"
      opacity=".8"
    />
    <title>No</title>
  </svg>
)

type Props = {
  ...SubtitleSectionProps,
  features: Array<{|
    title: string,
    icon: string,
    supportingBanks: Array<string>,
  |}>,
  banks: Array<{|
    name: string,
    logo: string,
  |}>,
}
export const ComparisonTable = ({
  features,
  banks,
  subtitle,
  blurb,
}: Props) => {
  return (
    <SectionWrapper
      theme={SectionThemes.LIGHT}
      className={styles.sectionWrapper}
      contentClassName={styles.baseContent}
    >
      {subtitle && (
        <SubtitleSection subtitle={subtitle} blurb={blurb} leftAlign={true} />
      )}
      <div className={styles.root}>
        <table className={styles.table}>
          <tbody>
            <tr>
              <th
                scope="col"
                className={cx(styles.headerTitle, styles.headerFeature)}
              >
                Features
              </th>
              {banks.map(bank => (
                <th
                  key={`header_${bank.name}`}
                  scope="col"
                  className={styles.headerBank}
                >
                  <img src={bank.logo} alt="" width={32} height={32} />
                  <br />
                  <span className={styles.bankName}>{bank.name}</span>
                </th>
              ))}
            </tr>
            {features.map(feature => {
              const featureNameKey = feature.title.replace(' ', '')
              return (
                <tr key={`row_${featureNameKey}`}>
                  <th scope="row" className={styles.headerFeature}>
                    <div className={styles.headerFeatureInner}>
                      <img
                        src={feature.icon}
                        alt=""
                        width={32}
                        height={32}
                        className={styles.featureIcon}
                      />
                      {feature.title}
                    </div>
                  </th>
                  {banks.map(bank => (
                    <td
                      key={`${bank.name}_${featureNameKey}`}
                      className={styles.cell}
                    >
                      {feature.supportingBanks.includes(bank.name) ? (
                        <CheckMark />
                      ) : (
                        <Cross />
                      )}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </SectionWrapper>
  )
}

export default ComparisonTable
